import { Controller } from "@hotwired/stimulus"

// Saves an answer the moment an option is chosen. The single-page exam has no submit
// button per question — the real exam's answer sheet does not either — and the server
// answers with a Turbo Stream, so the page never moves.
//
// Confidence rides in the same form. Chosen before an option, it waits and is sent with
// the option; chosen after, it saves on its own.
export default class extends Controller {
  save(event) {
    const chosen = this.element.querySelector("input[name=answer_option_id]:checked")
    if (!chosen) return

    // The single page carries each question twice, under it and on the answer sheet;
    // the other copy follows so switching views never shows a stale choice. A bubble
    // saves through the question's own form, which holds any confidence marked before
    // the student switched to the sheet.
    const mirror = event.target === chosen && chosen.dataset.mirror && document.getElementById(chosen.dataset.mirror)
    if (mirror) mirror.checked = true
    const carriesConfidence = mirror && mirror.form.querySelector("input[name=confidence]")
    ;(carriesConfidence ? mirror.form : this.element).requestSubmit()
  }
}
